import Ring from './Ring';

export default Ring;
